import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Layout from '../layout'

export const constantRoutes = [
  {
    path: '/login',
    component: () => import('../views/login'),
    meta: { title: '登录' },
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/components/404'),
    meta: { title: '404' },
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [{
      path: '/home',
      component: () => import('../views/home/index'),
      meta: { title: '首页' }
    }, {
      path: '/hall',
      component: () => import('../views/hall/index'),
      meta: { title: '办事大厅' }
    }, {
      path: '/apps',
      component: () => import('../views/apps/index'),
      meta: { title: '应用中心' }
    }, {
      path: '/task',
      component: () => import('../views/task/index'),
      meta: { title: '任务中心' }
    },
    ]
  },
  {
    path: '/guide',
    component: () => import('../views/guide/index'),
    meta: { title: '办事指南' }
  },
  {
    path: '/collection',
    component: () => import('../views/collection/index'),
    meta: { title: '收藏服务' }
  },
  {
    path: '/handle',
    component: () => import('../views/handle/index'),
    meta: { title: '服务办理' }
  },

  {
    path: '/personal',
    component: () => import('../views/personal/index'),
    meta: { title: '个人设置' }
  },
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

router.beforeEach((to, from, next) => {
  document.title = `一网通办 - ${to.meta.title}`
  next()
})

export default router
